import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import styles from './DeleteResourceModal.scss';

export const DeleteResourceModal = ({
  isOpen,
  onSave,
  onClose,
  isDeletable,
  collectionName,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      disableBackdropClick
      disableEscapeKeyDown
      classes={{ paper: styles.dialog_root }}
    >
      <CloseIcon
        style={{
          cursor: 'pointer',
          position: 'absolute',
          right: 10,
          top: 10,
          fontSize: 14,
        }}
        onClick={() => {
          onClose();
        }}
      />
      <DialogTitle>
        <span className={styles.dialog_header}>
          {isDeletable ? (
            `Delete collection "${collectionName}"?`
          ) : (
            <div>
              <div>This collection contains resources.</div>
              <div>
                Please delete or move them before deleting this collection.
              </div>
            </div>
          )}
        </span>
      </DialogTitle>

      <DialogActions style={{ marginRight: 20, marginTop: 80 }}>
        <Button onClick={onClose} variant="text" color="default">
          <span className={styles.button}>{isDeletable ? 'Cancel' : 'OK'}</span>
        </Button>
        {isDeletable ? (
          <Button
            onClick={onSave}
            color="primary"
            variant="contained"
            style={{ fontSize: 14 }}
          >
            Delete
          </Button>
        ) : null}
      </DialogActions>
    </Dialog>
  );
};

DeleteResourceModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isDeletable: PropTypes.bool.isRequired,
  collectionName: PropTypes.string.isRequired,
};
